import React from 'react';
import { AlertTriangle } from 'lucide-react';
export function StickyAlert() {
  return <div className="bg-danger text-white px-4 py-2.5 text-center text-sm md:text-base font-medium sticky top-0 z-50 shadow-lg flex items-center justify-center gap-2" data-id="element-265">
      <AlertTriangle className="w-4 h-4 md:w-5 md:h-5 animate-pulse" data-id="element-266" />
      <span data-id="element-267">
        <strong className="font-bold" data-id="element-268">
          OFERTA POR TIEMPO LIMITADO CON GARANTÍA 100%
        </strong>
      </span>
    </div>;
}